<template>
	<page-container :page="page">
		<main-content>
			<div class="row menu-items-wrapper">
				<div v-for="(menu, index) in menus" :key="menu.ID" class="menu-item" @mouseover="showByIndex = index">
					<div v-parse-links v-html="menu.menu" />
				</div>
				<div
					v-for="(menu, index) in menus"
					v-show="showByIndex === index"
					:key="menu.ID"
					class="menu-item-image"
				>
					<picture>
						<source :srcset="menu.image" />
						<img :src="menu.image" :alt="menu.imageAlt" loading="lazy" />
					</picture>
				</div>
			</div>
			<div v-if="page.content" class="row">
				<div class="columns column12">
					<div class="sub-content-wrapper">
						<div v-parse-links v-html="page.content" />
					</div>
				</div>
			</div>
		</main-content>

		<contentblocks :items="page.contentblocks" />
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const showByIndex = ref(null);

const { data: menus } = await useWebsiteFetch('menus', {
	query: { language: locale.value },
	key: `${locale.value}/menus`,
});
</script>

<style lang="scss" scoped>
.menu-items-wrapper {
	display: flex;
	flex-flow: column wrap;
	width: 100%;
	height: 100%;
	justify-content: flex-start;
	align-items: flex-start;
	padding: 60px 60px 60px 130px;
	position: relative;
	min-height: 75vh;

	div {
		z-index: 3;
		position: relative;
		margin: 10px 0;
	}

	:deep(.button) {
		padding: 6px 12px;
		background: #fff;
		color: #000;
		text-align: left;
		border: 1px solid #000;
		min-width: 160px;
		max-width: 100%;
		display: inline-block;
		text-decoration: none;

		&:hover {
			background: rgb(255 255 255 / 0%);
			color: #fff;
			border-color: #fff;
			text-decoration: none;
		}
	}

	.menu-item-image {
		position: absolute;
		inset: 0 0 0 60px;
		z-index: 2;
		transition: all 0.3s ease-in-out;
		max-width: 1000px;

		img {
			object-fit: cover;
			height: 100%;
			width: 100%;
		}

		&:last-child {
			z-index: 1;
			display: block !important;
		}
	}
}

@media (max-width: 1200px) {
	.menu-items-wrapper {
		img {
			width: auto;
		}
	}
}
</style>
